import { render, staticRenderFns } from "./TreeConfig.vue?vue&type=template&id=4d578cf2&scoped=true&"
import script from "./TreeConfig.vue?vue&type=script&lang=js&"
export * from "./TreeConfig.vue?vue&type=script&lang=js&"
import style0 from "./TreeConfig.vue?vue&type=style&index=0&id=4d578cf2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d578cf2",
  null
  
)

export default component.exports